import cn from 'classnames'
import React, { ComponentProps, ReactElement } from 'react'

import style from './Pill.style'

export type PillProps = {
  className?: string
  color?: 'highlight' | 'new' | 'severe' | 'pending' | 'saas' | 'shiny'
  size?: 'small' | 'medium' | 'large' | 'xlarge'
  children: string | ReactElement
} & ComponentProps<'div'>

function Pill(props: PillProps): ReactElement {
  const { className = '', color, size = 'medium', children, ...rest } = props

  return (
    <div
      className={cn('Pill', color, size, className, {
        clickable: !!props.onClick,
      })}
      css={style}
      {...rest}
    >
      <p>{children}</p>
    </div>
  )
}

export default Pill
